module.exports = __webpack_public_path__ + "img/pexels-cottonbro-4910828.badad9b6.jpg";